const ru = {
    demo: {
        title: 'Russian',
        introduction:
            'Lorem Ipsum - это текст-"рыба", часто используемый в печати и веб-дизайне. Lorem Ipsum является стандартной "рыбой" для текстов на латинице с начала XVI века.',
    },
    docs: {
        hi: 'Привет',
        description:
            'Нужна помощь? \n Пожалуйста, ознакомьтесь с нашей документацией.',
        documentation: 'документация',
    },
    app: 'Приложение',
    user: 'Пользователь',
    list: 'Список',
    edit: 'Редактировать',
    shop: 'Магазин',
    blog: 'Блог',
    post: 'Пост',
    mail: 'Почта',
    chat: 'Чат',
    cards: 'Карточки',
    posts: 'Посты',
    create: 'Создать',
    kanban: 'Канбан',
    general: 'Общие',
    banking: 'Банкинг',
    booking: 'Бронирование',
    profile: 'Профиль',
    account: 'Аккаунт',
    product: {
        benefit: 'выгода',
    },
    invoice: 'Счет',
    details: 'Детали',
    checkout: 'Оформление',
    calendar: 'Календарь',
    analytics: 'Аналитика',
    ecommerce: 'Электронная коммерция',
    management: 'Управление',
    menu_level: 'Уровень меню',
    menu_level_2a: 'Уровень меню 2a',
    menu_level_2b: 'Уровень меню 2b',
    menu_level_3a: 'Уровень меню 3a',
    menu_level_3b: 'Уровень меню 3b',
    menu_level_4a: 'Уровень меню 4a',
    menu_level_4b: 'Уровень меню 4b',
    item_disabled: 'Элемент отключен',
    item_label: 'Элемент с меткой',
    item_caption: 'Элемент с подписью',
    item_external_link: 'Внешняя ссылка',
    description: 'Описание',
    other_cases: 'Другие случаи',
    item_by_roles: 'Элемент по ролям',
    only_admin_can_see_this_item: 'Только админ может видеть этот элемент',
    dashboard: 'Дашборд',
    auth: {
        logout: 'Выйти',
        tech_support: 'Тех. поддержка',
    },
    banners: {
        practicum: {
            title: 'Практикум',
            description: 'Обучающие материалы и практические задания для эффективной работы.',
            button: 'Перейти',
        },
        news: {
            title: 'Новости',
            description: 'Последние обновления, новости и важные объявления.',
            button: 'Читать',
        },
    },
    companies: {
        name_company: 'Название магазина',
        edit_shop: 'Редактировать магазин',
        shops_list: 'Список магазинов',
        add_shop: 'Добавить магазин',
        set_manager: 'Назначить менеджера',
        time_working: 'Время работы',
        token_tg: 'Токен Telegram',
        your_companies: 'Ваши магазины',
    },
    employees: {
        calculate_wage: 'Рассчитать зарплату',
        self: 'Сотрудники',
    },
    games: {
        leaderboard: {
            balance: 'Баланс',
            referral: 'Реферал',
        },
    },
    qs: {
        One_company: 'Одна компания',
        One_service: 'Одна услуга',
        One_staff: 'Один сотрудник',
        at_least: 'Как минимум',
        first_add: 'Сначала добавьте',
        name_desc_adr: 'Название, Описание, Адрес',
        name_price_duration: 'Название, Цена, Длительность',
        namestaff_specialization: 'Имя, Сотрудник, Специализация',
        open_recording_set_time: 'Откройте запись, Установите время',
        set_staff_schedule: 'Установите расписание сотрудников',
        staff_service: 'Услуга сотрудника',
        to_staff: 'Сотруднику',
    },
    services: {
        self: 'Услуги',
    },
    system: {
        add: 'Добавить',
        address: 'Адрес',
        allowed: 'Разрешено',
        are_you_sure_want_to_delete: 'Вы уверены, что хотите удалить?',
        contacts: 'Контакты',
        copied: 'Скопировано',
        create: 'Создать',
        delete: 'Удалить',
        description: 'Описание',
        edit: 'Редактировать',
        max_size_of: 'Максимальный размер',
        partners: 'Партнеры',
        save_changes: 'Сохранить изменения',
        selected: 'Выбрано',
        view_all: 'Посмотреть все',
        // Merged from my_ru.json
        "sort by date": "Сортировка по дате",
        newest: "Сначала новые",
        oldest: "Сначала старые",
        back: "Назад",
        select_category: "Выбрать категорию",
        change_category: "Изменить категорию",
        back_to_channel: "Вернуться в канал",
        back_to_list: "Вернуться к списку",
        back_to_cart: "Вернуться в корзину",
        add_to_cart: "в Корзину",
        add_to_order: "Добавить к заказу",
        go_to_order: "К оформлению",
        buy_now: "Купить сейчас",
        cancel: "Отменить",
        exit: "Выйти",
        clear: "Очистить",
        apply: "Применить",
        items: "элементов",
        create_success: "Всё получилось!",
        create_fail: "Что-то пошло не так!",
        update_success: "Обновили, всё хорошо!",
        Save: "Сохранить",
        save: "Сохранить",
        saving: "Сохраняем...",
        short_description: "Короткое описание",
        "copy created": "Копия создана!",
        "create copy": "Создать копию",
        copy: "Скопировать",
        search: "Найти...",
        search_by_name_or_phone: "Поиск по имени или номеру телефона...",
        items_selected: "Выбрано записей",
        logout: "Выход",
        home: "Главная",
        unable_to_logout: "Невозможно выйти!",
        profile: "Профиль",
        settings: "Настройки",
        integrations: "Интеграции",
        active: "Активна",
        dont_active: "Неактивна",
        max_files_of: "макс. количество файлов",
        upload_files: "Загрузите файлы",
        upload_to_server: "Загрузить на сервер",
        pay: "Перейти к оплате",
        email_must_be_a_valid_email_address: "Некорректный Email",
        phone_is_required: "Телефон обязательное поле",
        email_is_required: "Email обязательное поле",
        firstname_name_is_required: "Имя обязательное поле",
        Add_event: "Новое событие",
        Edit_event: "Редактировать событие",
        results_found: "объектов найдено",
        Colors: "Цвета",
        Date: "Дата",
        Events: "События",
        enter_number_value: "Укажите числовое значение",
        enter_percent_value: "Укажите количество процентов от 0 до 100",
        current_she: "текущая",
        subscribers: "Подписчики",
        newsletter: "Рассылка",
        close: "Закрыть",
        minutes: "минуты",
        hours: "часы",
        article: "Статья",
        articles: "Статьи",
        product: "Товар",
        form: "Форма",
        action: "Действие",
        condition: "условие",
        conditions: "условия",
        open: "Открыл",
        Open: "Открыть",
        do_not_open: "Не открыл",
        fill: "Заполнил",
        did_not_fill: "Не заполнил",
        bought: "Купил",
        did_not_buy: "Не купил",
        pages: "Страница",
        add_page: "Добавить страницу",
        add_product: "Добавить товар",
        header: "Заголовок",
        subheader: "Подзаголовок",
        to: "до",
        send: "Отправить",
        "withdraw ": "Вывести ",
        finalize_order: "Завершить заказ",
        finalize: "Завершить",
        share: "Поделиться",
        files: "файлов",
        are_you_sure: "Вы уверены?",
        delete_confirmation_content: "Вы уверены, что хотите удалить {{count}} записей?",
        there_is_no_information_here_yet: "Здесь пока нет информации",
        basket: "Корзина\\",
        "1_month": "1 мес.",
        "1_year": ">1 год.",
        "3_month": "3 мес.",
        "6_month": "6 мес.",
        bot_subscribers: "Подписчики бота",
        read_more: "Подробнее",
        filter: "Отфильтровать",
        categories: "Категории",
        access_open: "Доступ открыт",
        access_close: "Доступ закрыт",
        be_opened: "откроется",
        be_closed: "закроется",
        time_left: "осталось",
        left_days: "дней",
        left_hours: "часов",
        left_minutes: "минут",
        left_seconds: "секунд",
        link_need_http: "Ссылка должна начинаться с http:// или https://",
        button: "Кнопка",
        status: "Статус",
        complete_order_soglasie: "Я согласен на [обработку персональных данных]({{agreements_link}})",
        complete_order_agreement: "Нажимая кнопку \"Завершить заказ\" я соглашаюсь с [Договором оферты]({{public_offer}}) и [политикой конфиденциальности]({{policy_link}})",
        fill_in_data: "Заполните данные"
    },
    payment: {
        self: "Оплата",
        pay_to: "Оплатить",
        monthly: "на месяц",
        mo: "мес",
        popular: "Популярно",
        usercard: "Визитка",
        basic: "Базовый",
        premium: "Pro",
        starter: "Free",
        unlim: "Под ключ",
        current_plan: "Текущий тариф",
        pay_basic: "Оплатить Базовый",
        pay_premium: "Оплатить Pro",
        pay_unlim: "Оплатить Под ключ",
        yearly: "На Год",
        saving: "экономия 40% при оплате на год",
        saving_yearly: "Экономия {price}₽ при оплате за год",
        saving_price: "Экономия {price}₽",
        tariff: "Тариф",
        total_billed: "Итого",
        total_billed_price: "к оплате {price}₽",
        amount: "Сумма",
        main_screen_catalog: "Главный экран только Каталог",
        vitrina_app: "Приложение Магазин",
        launch_from_any_dialog: "Запуск приложения из любого диалога",
        autosubscription_on_start: "Автоподписка в чат-бот при запуске",
        "10_goods_5_articles": "10 товаров и 5 страниц",
        "5_goods_5_articles": "5 товаров и 5 страниц",
        goods_cart: "Корзина товаров",
        manual_payment_methods: "Ручные способы оплаты",
        manual_orders: "Ручной приём заказов",
        order_notifications: "Уведомления о заказе админу и клиенту",
        subscriber_access_only: "Проверка подписки на канал",
        telegraph_integration: "Интеграция с Telegraph",
        standard_launch_button: "Стандартная кнопка запуска в канал/чат",
        integration_with_vk: "Интеграция с вк",
        application_in_telegram_bot: "Применение в telegram-боте",
        telegram_bot_for_booking: "Telegram-бот для бронирования",
        integration_with_clients: "Интеграция с клиентами",
        main_screen_catalog_vizitka: "Главный экран: Каталог и Визитка",
        everything_in_vitrina: "Всё, что есть в тарифе Free",
        "50_goods_20_articles": "50 товаров и 20 страниц",
        "500_goods_100_articles": "500 товаров и 100 страниц",
        "Pro blocks usercard": "PRO блоки в визитке",
        "Pro blocks articles": "PRO блоки в страницах",
        active_users: "активных пользователей в рассылке",
        "white label": "Отключение подписи «Работает на Notibot»",
        "when paying for a year": "при оплате на год",
        "payment by points": "Оплата ваших товаров баллами",
        vizitka_app: "Приложение ВИЗИТКА",
        "10_review_gallery_photos": "10 фото в галерее отзывов",
        "10_portfolio_photos": "10 фото в портфолио",
        custom_launch_button: "Настраиваемая кнопка запуска в канал/чат",
        launch_button_article: "Кнопка в закрепе может запускать отдельную статью",
        min_landing_pages: "Мини лендинги из статей Telegraph",
        everything_in_vitrina_basic: "Всё из предыдущих тарифов",
        vitrina_vizitka_auto_payments_mailings: "Витрина/Визитка/Автоплатежи/Рассылки",
        subscriber_marketing_emails: "маркетинговые электронные письма подписчикам",
        mailings_for_all_users: "Рассылки по всем кто запускал приложение",
        auto_notify_book_reminder: "Автоматический прием оплат",
        automatic_payment_receipt: "Автоматический прием оплат",
        integration_with_prodamus: "Интеграция с Продамус/Робокасса/Leadpay/Юкасса/Юмани...",
        integration_with_tbank: "Интеграция с Т-Банк",
        integration_with_crm: "Интеграция с АмоCRM / ГетКурс",
        built_in_response_app: "Встроенное приложение для ответов",
        launch_button_specific_article: "Кнопка в закрепе может запускать отдельную статью",
        min_landing_pages_telegraph: "Мини лендинги из статей Telegraph",
        application_forms: "Формы сбора заявок",
        quizzes_tests_surveys: "Квизы / Тесты / Викторины",
        quizzes: "Формы-Квизы",
        tests_surveys: "Тесты / Викторины",
        tests_surveys_ai: "Генерация тестов и викторин с помощью ИИ",
        "number of administrators": "Кол-во администраторов",
        "dedicated support line": "Отдельная линия поддержки",
        "short codes": "Шорткоды (таймеры/ и пр блоки для автоворонки)",
        "chatbot and automation": "Чат-бот и автоматизация",
        gamification: "Геймификация (система баллов и др.)",
        "wheels of fortune": "Колесо фортуны",
        club: "Клуб (Канал/чат по подписке)",
        "referral program": "Реферальная программа",
        "connecting personal account": "Подключение к личному аккаунту",
        courses_marathons_web3: "Курсы/марафоны/Автоворонка Web 3.0",
        segmented_mailings: "Сегментированные рассылки",
        book_confirmation: "Подтверждение бронирования",
        invitation_for_return_visits: "Приглашение на повторный визит",
        dealing_with_lost_clients: "Работа с потерянными клиентами",
        feedback_request: "Запрос на отзыв",
        interception_of_negative_reviews: "Перехват негативных отзывов",
        we_will_create_app_for_you: "Сделаем приложение за Вас",
        we_will_set_up_and_connect_everything: "Всё настроим всё подключим",
        provide_video_instructions: "Дадим видео инструкции",
        unlim_tariff_included: "Включен Тариф ПРИЛОЖЕНИЕ на 1мес или 1год",
        priority_support_one_month: "1 месяц приоритетная поддержка",
        integration_with_yclients: "",
        integration_with_viber: "Интеграция с Viber",
        more_about_the_tariff: "Подробнее о тарифе",
        successful_tariff_payment: "Успешная Оплата тарифа",
        tariff_payment_error: "Ошибка оплаты тарифа"
    },
    form: {
        required: "Обязательный вопрос",
        incorrect_answer: "Не верный ответ",
        form: "Форма",
        you_have_already_filled_out_the_form: "Вы уже заполнили форму",
        invalid_email_format: "Не верный формат email",
        invalid_phone_format: "Не верный формат номера телефона",
        policy_: "Согласен с условиями использования формы заявки и [политикой конфиденциальности](:link) лица, разместившего форму заявки.",
        policy: "Нажимая кнопку Отправить, Вы даете свое [согласие на обработку персональных данных](:link)",
        agree: "Я согласен на [обработку персональных данных]({{agreements_link}})",
        mailing: "Даю согласие на [получение информационных и маркетинговых рассылок]({:link) (Вы в любой момент можете отказаться от получения писем)",
        agree_2: "Я даю согласие на [обработку персональных данных]({{agreements_link}}) согласно [политике конфиденциальности]({{policy_link}})",
        start_typing: "Начните ввод...",
        details: "Детали",
        phone: "Телефон",
        delivery_method: "Способ доставки",
        address: "Адрес доставки",
        delivery_price: "Стоимость доставки"
    },
};

export default ru;
